import Gravity from "Gravity";

const contactUsForm = () => {
    if (!document.querySelector(".gg-contact-us-form")) {
        return;
    }

    /* eslint-disable */
    jQuery(document).ready(() => {
        jQuery(document).on("gform_confirmation_loaded", (_e, formID) => {
            document
                .querySelector(`#gform_confirmation_wrapper_${formID}`)
                .closest(".gg-contact-us-form")
                ?.classList.add("gg-contact-us-form__successful");
        });

        jQuery(document).on("gform_post_render", function () {
            formInit();
        });
    });

    /* eslint-enable */

    function formInit() {
        const fields = document.querySelectorAll(
            '.gg-contact-us-form input[type="text"], .gg-contact-us-form input[type="email"], .gg-contact-us-form textarea',
        );
        const inputEmailErrorMsg = document.querySelector(
            ".gfield--type-email",
        );

        fields.forEach((field) => {
            field.addEventListener("focus", () => {
                field.closest(".gfield").classList.add("active-input");
            });

            field.addEventListener("focusout", () => {
                if (field.value === "") {
                    field.closest(".gfield").classList.remove("active-input");
                }
            });

            if (field.value !== "") {
                field.closest(".gfield").classList.add("active-input");
            }
        });

        if (inputEmailErrorMsg.classList.contains("active-input")) {
            const errorHtml = inputEmailErrorMsg.querySelector(
                ".gfield_validation_message",
            );
            errorHtml.innerHTML = "Please enter a valid email address";
        }
    }

    formInit();
};
Gravity.ready(contactUsForm);
